/* VK · imágenes diferidas (2026-09)
   La segunda foto de cada tarjeta de producto sale con data-src/data-srcset y sin src:
   solo se descarga cuando el puntero entra a la tarjeta (o recibe foco). En móvil no hay hover,
   así que nunca se descarga: la mitad de las imágenes de la home dejan de pedirse. */
(function () {
  function activate(img) {
    if (!img || img.dataset.vkReady) return;
    img.dataset.vkReady = '1';
    if (img.dataset.sizes) img.setAttribute('sizes', img.dataset.sizes);
    if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
    if (img.dataset.src) img.setAttribute('src', img.dataset.src);
  }
  function activateWithin(root) {
    root.querySelectorAll('img[data-src]:not([src])').forEach(activate);
  }
  function bind(root) {
    root.querySelectorAll('.thb-hover').forEach(function (fig) {
      if (fig.dataset.vkHover) return;
      fig.dataset.vkHover = '1';
      var once = function () { activateWithin(fig); };
      fig.addEventListener('mouseenter', once, { passive: true, once: true });
      fig.addEventListener('focusin', once, { passive: true, once: true });
    });
  }
  bind(document);
  /* Contenido que llega por AJAX (filtros de colección, "cargar más", recomendaciones) */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) bind(added[j]);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  window.vkActivateDeferredImages = activateWithin;

  /* Galería del producto (2026-09-16): las fotos salen con loading="lazy" y las que están
     fuera de pantalla no se descargan hasta que se deslizan → el swipe mostraba un hueco.
     Tras el load (o al primer toque) se pasan a eager para que ya estén en caché. */
  function warmGallery() {
    document.querySelectorAll('.product-images img[loading="lazy"], .product-thumbnail-container img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
    });
  }
  if (document.querySelector('.product-images')) {
    var warm = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(warmGallery, { timeout: 2500 });
      else setTimeout(warmGallery, 800);
    };
    if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm, { once: true });
    document.addEventListener('touchstart', warmGallery, { once: true, passive: true });
  }
})();
